module.exports = __webpack_public_path__ + "img/btn-intro-movie@3x.a9ee6165.jpg";